import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Dependencies
import currencyFormatter from 'currency-formatter';
import moment from 'moment';

const PaymentSessions = observer(class PaymentSessions extends React.Component {
  componentWillMount() {
    // Get initial balance
    this.props.store.PaymentStore.getBalance(true);
  }

  render() {
    const { translation } = this.props;
    const { paymentSessions } = this.props.store.PaymentStore;

    if(paymentSessions.length > 0) {
      return (
        <table>
          <thead>
            <tr>
              <th id="heading-date" className="subtitle" scope="col">{translation.date}</th>
              <th id="heading-session" className="subtitle" scope="col">{translation.session}</th>
              <th id="heading-amount" className="subtitle" scope="col">{translation.amount}</th>
            </tr>
          </thead>
          <tbody>
            {paymentSessions.map(
              (session, i) =>
              <tr key={i}>
                <td aria-labelledby="heading-date">
                  {moment(session.appointmentDate).local().tz(moment.tz.guess()).format('M/D/YYYY [at] h:mma z')}
                </td>
                <td aria-labelledby="heading-session">
                  {session.lastName}, {session.firstName}
                </td>
                <td aria-labelledby="heading-amount" className="number">
                  {currencyFormatter.format(session.netAmount, {code: this.props.currency})}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      )
    } else {
      return (
        <span className="no-results">{translation.no_results}</span>
      )
    }
  }
})

export default translate('PaymentSessions')(PaymentSessions);


// WEBPACK FOOTER //
// ./src/app/components/Payments/PaymentSessions.js